export default __webpack_public_path__ + "static/media/gestaoBanner.4330ed14.jpg";